import { BuildFontString } from "../utils/BuildFontString";
import { kDefaultFontSize } from "../constants";
import { QXMLObject } from "./QXMLObject";
import { Globals } from "./Globals";
import { StringToBool } from "../utils/StringToBool.js";

export class QTextFormat extends QXMLObject {
  constructor() {
    super();
    this.fFontName = "Tahoma"; // Arial							// Selected font
    this.fFontSize = kDefaultFontSize; // Font size
    this.fFontColor = "#000000"; // kOCNTextColor;		// Font color (black)

    this.fBold = false;
    this.fItalic = false;
    this.fUnderline = false;

    this.fFontString = null;
    this.fOverrides = null;

    // Shadow?
    // this.SetXMLElementName("textformat");
  }

  InitTextFormat() {
    this.fOverrides = {};
  }

  Clone() {
    var c = new QTextFormat();
    c.InitTextFormat();

    c.fFontName = this.fFontName;
    c.fFontSize = this.fFontSize;
    c.fFontColor = this.fFontColor;
    c.fBold = this.fBold;
    c.fItalic = this.fItalic;
    c.fUnderline = this.fUnderline;
    c.fOverrides = { ...(this.fOverrides || {}) };
    c.fFreeText = this.fFreeText;

    return c;
  }

  HasOverrides() {
    return this.fOverrides && Object.keys(this.fOverrides).length > 0;
  }

  GetXMLElementName() {
    return "textformat";
  }

  Compare(textFormat) {
    if (textFormat == null) return false;

    if (textFormat.fFontName != this.fFontName) return false;

    if (textFormat.fFontSize != this.fFontSize) return false;

    if (textFormat.fFontColor != this.fFontColor) return false;

    if (textFormat.fBold != this.fBold) return false;

    if (textFormat.fItalic != this.fItalic) return false;

    if (textFormat.fUnderline != this.fUnderline) return false;

    return true;
  }

  //=================================================================================================
  // Load/Save Methods
  OutputSubElements(stream) {
    this.OutputElementTriple("fontprops", this.fFontName, this.fFontSize, this.fFontColor, stream);
    this.OutputElementTriple("fontmods", this.fBold, this.fItalic, this.fUnderline, stream);
  }

  LoadFromJSON(data) {
    if (data == null) {
      this.fFontName = Globals._priorTextFormat.fFontName;
      this.fFontSize = Globals._priorTextFormat.fFontSize;
      this.fFontColor = Globals._priorTextFormat.fFontColor;
      this.fBold = Globals._priorTextFormat.fBold;
      this.fItalic = Globals._priorTextFormat.fItalic;
      this.fUnderline = Globals._priorTextFormat.fUnderline;
    } else {
      this.fFontName = data["font"];
      this.fFontSize = data["size"];
      this.fFontColor = data["color"];

      this.fBold = data["bold"];
      this.fItalic = data["italic"];
      this.fUnderline = data["underline"];
    }
    Globals._priorTextFormat = this;
  }

  LoadSubElements(objTree) {
    if (objTree == null) {
      this.fFontName = Globals._priorTextFormat.fFontName;
      this.fFontSize = Globals._priorTextFormat.fFontSize;
      this.fFontColor = Globals._priorTextFormat.fFontColor;
      this.fBold = Globals._priorTextFormat.fBold;
      this.fItalic = Globals._priorTextFormat.fItalic;
      this.fUnderline = Globals._priorTextFormat.fUnderline;
    } else {
      var valueList = objTree.GetValueListForChild("fontprops", false);
      this.fFontName = valueList[0];
      this.fFontSize = parseInt(valueList[1]);
      this.fFontColor = valueList[2];

      valueList = objTree.GetValueListForChild("fontmods", false);
      this.fBold = StringToBool(valueList[0]);
      this.fItalic = StringToBool(valueList[1]);
      this.fUnderline = StringToBool(valueList[2]);
    }

    Globals._priorTextFormat = this;
  }

  BuildFontString() {
    if (this.fFontString == null) {
      //var fs = BuildFontString(this.fFontName, this.fFontSize, this.fBold, this.fItalic);
      //return fs;
      var fontName = this.GetOverridesKey("fFontName", this.fFontName);
      var fontSize = this.GetOverridesKey("fFontSize", this.fFontSize);
      var bold = this.GetOverridesKey("fBold", this.fBold);
      var italic = this.GetOverridesKey("fItalic", this.fItalic);
      var underline = this.GetOverridesKey("fUnderline", this.fUnderline);
      this.fFontString = BuildFontString(fontName, fontSize, bold, italic, underline);
    }

    return this.fFontString;
  }

  //=================================================================================================
  // Get/Set Methods
  GetFontColor() {
    return this.GetOverridesKey("fFontColor", this.fFontColor);
  }

  SetFontColor(fontColor) {
    this.fFontColor = fontColor;
  }

  SetOverrideFontColor(fontColor) {
    this.fOverrides["fFontColor"] = fontColor;
    // this.fFontColor = fontColor;
  }

  GetFontName() {
    return this.GetOverridesKey("fFontName", this.fFontName);
  }

  SetFontName(fontName) {
    this.fFontName = fontName;
    this.fFontString = null;
  }

  SetOverrideFontName(fontName) {
    this.fOverrides["fFontName"] = fontName;
    this.fFontString = null;
  }

  GetFontSize() {
    return this.GetOverridesKey("fFontSize", this.fFontSize);
  }

  SetFontSize(fontSize) {
    this.fFontSize = fontSize;
    this.fFontString = null;
  }

  SetOverrideFontSize(fontSize) {
    this.fOverrides["fFontSize"] = fontSize;
    this.fFontString = null;
  }

  //Text Bold
  GetTextBold() {
    return this.GetOverridesKey("fBold", this.fBold);
  }

  SetTextBold(setOn) {
    this.fBold = setOn;
    this.fFontString = null;
  }

  SetOverrideTextBold(setOn) {
    this.fOverrides["fBold"] = setOn;
    this.fFontString = null;
  }

  //Text Italic
  GetTextItalic() {
    return this.GetOverridesKey("fItalic", this.fItalic);
  }

  SetOverrideTextItalic(setOn) {
    this.fOverrides["fItalic"] = setOn;
    this.fFontString = null;
  }

  SetTextItalic(setOn) {
    this.fItalic = setOn;
    this.fFontString = null;
  }

  //Text Underline
  GetTextUnderline() {
    return this.GetOverridesKey("fUnderline", this.fUnderline);
  }

  SetOverrideTextUnderline(setOn) {
    this.fOverrides["fUnderline"] = setOn;
    this.fFontString = null;
  }

  SetTextUnderline(setOn) {
    this.fUnderline = setOn;
    this.fFontString = null;
  }
}
